export const BIOMASS_CATEGORIES = [
  "agriculture",
  "forest",
  "industryWaste",
  "infrastructure",
  "nonforest"
];

export const FOREST_INTERVENTIONS = [
  "thinning",
  "clearcut",
  "pollarding",
  "coppicing",
  "pruning",
] as const;

export const AGRICULTURE_AND_NONFOREST_INTERVENTIONS = [
  "thinning",
  "clearing",
  "pollarding",
  "coppicing",
  "pruning",
] as const;

export const THINNING_LIKE_INTERVENTIONS = ["thinning", "pollarding", "pruning"] as const;
export const CLEARCUT_LIKE_INTERVENTIONS = ["clearcut", "coppicing"] as const;
export const FELLING_AND_THINNING_INTERVENTIONS = [
  "fellingAndThinning",
  ...THINNING_LIKE_INTERVENTIONS,
] as const;
export const CLEARING_INTERVENTIONS = ["clearing", ...CLEARCUT_LIKE_INTERVENTIONS] as const;

const normalizeInterventions = (interventions?: readonly string[] | string | null) =>
  typeof interventions === "string" ? [interventions] : interventions ?? [];

export const hasThinningLikeIntervention = (interventions?: readonly string[] | string | null) =>
  normalizeInterventions(interventions).some((intervention) =>
    (THINNING_LIKE_INTERVENTIONS as readonly string[]).includes(intervention),
  );

export const hasClearcutLikeIntervention = (interventions?: readonly string[] | string | null) =>
  normalizeInterventions(interventions).some((intervention) =>
    (CLEARCUT_LIKE_INTERVENTIONS as readonly string[]).includes(intervention),
  );

export const hasFellingAndThinningIntervention = (
  interventions?: readonly string[] | string | null,
) =>
  normalizeInterventions(interventions).some((intervention) =>
    (FELLING_AND_THINNING_INTERVENTIONS as readonly string[]).includes(intervention),
  );

export const hasClearingIntervention = (interventions?: readonly string[] | string | null) =>
  normalizeInterventions(interventions).some((intervention) =>
    (CLEARING_INTERVENTIONS as readonly string[]).includes(intervention),
  );

export const shouldShowRegenerationAgreement = (
  category: string | null | undefined,
  interventions?: readonly string[] | string | null,
) =>
  (category === "forest" && hasClearcutLikeIntervention(interventions)) ||
  (category === "nonforest" && hasClearingIntervention(interventions));

export const APPENDIX_16 = [
  { id: "1a", label: "1a" },
  { id: "1b", label: "1b" },
  { id: "2a", label: "2a" },
  { id: "2b", label: "2b" },
  { id: "3a", label: "3a" },
  { id: "3b", label: "3b" },
  { id: "4a", label: "4a" },
  { id: "4b", label: "4b" },
  { id: "4c", label: "4c" },
  { id: "4d", label: "4d" },
];

export const APPENDIX_25 = [
  { id: "1a", label: "1a" },
  { id: "1b", label: "1b" },
  { id: "2a", label: "2a" },
  { id: "2b", label: "2b" },
  { id: "3a", label: "3a" },
  { id: "3b", label: "3b" },
  { id: "4a", label: "4a" },
  { id: "4b", label: "4b" },
  { id: "5a", label: "5a" },
  { id: "5b", label: "5b" },
];

export const HNV_FOREST = [
  { id: "1", label: "1" },
  { id: "2", label: "2" },
  { id: "3", label: "3" },
  { id: "4", label: "4" },
  { id: "5", label: "5" },
  { id: "6", label: "6" },
  { id: "7", label: "7" },
  { id: "8", label: "8" },
  { id: "9", label: "9" },
  { id: "10", label: "10" },
  { id: "11", label: "11" },
  { id: "12", label: "12" },
  { id: "13", label: "13" },
  { id: "14", label: "14" },
  { id: "15", label: "15" },
  { id: "16", label: "16" },
  { id: "17", label: "17" },
  { id: "18", label: "18" },
  { id: "19", label: "19" },
];

export const HNV = [
  { id: "0", label: "0" },
  { id: "1", label: "1" },
  { id: "2", label: "2" },
  { id: "3", label: "3" },
  { id: "4", label: "4" },
  { id: "5", label: "5" },
  { id: "6", label: "6" },
  { id: "7", label: "7" },
  { id: "8", label: "8" },
  { id: "9", label: "9" },
  { id: "10", label: "10" },
  { id: "11", label: "11" },
  { id: "12", label: "12" },
  { id: "13", label: "13" },
  { id: "14", label: "14" },
];

export const FORESTRY_EVALUATION_ASSESSMENT_OPTIONS = [
  "feaoId1",
  "feaoId2",
  "feaoId3",
  "feaoId4",
  "feaoId5",
];
